import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[dialogFooter]',
  standalone: true
})
export class DialogFooterDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
